import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import './chat-message.scss';

interface IChatMessageProps {
  message: string;
  isMyMessage: boolean;
  date: string;
  user: string;
}

const ChatMessage: FunctionComponent<IChatMessageProps> = ({ message, isMyMessage, date, user }) => (
  <div className="chat-message-holder">
    <div
      className={classNames('chat-message', {
        'chat-message-incoming': isMyMessage,
      })}
    >
      <div className='user-nick'>
        <h6 className='truncated'>{user}</h6>
        <h6>{date}</h6>
      </div>

      <p>{message}</p>
    </div>
  </div>
);

export default ChatMessage;
